/**
 * API URL 설정
 * - LAN 접속 (192.168.x.x, localhost): 직접 포트 접근
 * - 외부 접속 (Tailscale Funnel): 프록시 경로 사용
 */

function isExternalAccess(): boolean {
  const hostname = window.location.hostname;
  return hostname.includes('ts.net') || hostname.includes('tailscale');
}

/** webapp backend (포트 3010) */
export function getWebappApiUrl(): string {
  if (isExternalAccess()) {
    return `${window.location.origin}/webapp-api`;
  }
  return `http://${window.location.hostname}:3010`;
}

/** API Gateway (포트 3001) */
export function getApiGatewayUrl(): string {
  if (isExternalAccess()) {
    return `${window.location.origin}/backend`;
  }
  return `http://${window.location.hostname}:3001`;
}

/** WebApp backend request with the HttpOnly session cookie. */
export function webappFetch(input: RequestInfo | URL, init: RequestInit = {}): Promise<Response> {
  return fetch(input, {
    ...init,
    credentials: 'include'
  });
}
